import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { IRsvpAdditionalGuest, RsvpStatus } from "@/models"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { RsvpResponse } from "@/models"

interface UpdateRsvpResponseArgs {
  name: string
  email?: string
  additionalGuests?: IRsvpAdditionalGuest[]
  rsvpDetails: {
    rsvpStatus: RsvpStatus
    guestRSVPComment?: string
    dietaryRequirements?: string
    songRequests?: string
    guestCount?: number
  }
}

export interface IUpdateRsvpResponseArgsParams {
  eventAlbumId?: number
  token?: string
  guestId?: number
}

export async function updateRsvpResponse(rsvpResponse: UpdateRsvpResponseArgs, eventVaultId: number, emailToken?: string, guestId?: number, albumId?: number) {
  const payload: UpdateRsvpResponseArgs = {
    ...rsvpResponse,
    ...("additionalGuests" in rsvpResponse ? { additionalGuests: rsvpResponse.additionalGuests } : {}),
  }

  const options: AxiosRequestConfig = {}

  const params: IUpdateRsvpResponseArgsParams = {
    token: emailToken,
    eventAlbumId: albumId,
    guestId,
  }

  if (params.eventAlbumId || params.guestId || params.token) {
    options.params = params
  }

  const response = await v1.patch(`/events/${eventVaultId}/rsvp`, payload, options)

  return RsvpResponse.fromResponse(response.data.data)
}

export const UPDATE_RSVP_RESPONSE = "updateRsvpResponse"

export function useUpdateRsvpResponse(eventVaultId?: MaybeRef<number | undefined>, emailToken?: MaybeRef<string | undefined>, guestId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: [UPDATE_RSVP_RESPONSE, eventVaultId, emailToken, guestId, albumId],
    mutationFn: (rsvpResponse: UpdateRsvpResponseArgs) => updateRsvpResponse(rsvpResponse, toValue(eventVaultId)!, toValue(emailToken), toValue(guestId), toValue(albumId)),
  })
}
